@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.account.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.flowyride.feature.account.resources/"

@delegate:ResourceContentHash(-1_693_728_645)
internal val Res.string.account_menu: StringResource by lazy {
      StringResource("string:account_menu", "account_menu", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

@delegate:ResourceContentHash(248_868_102)
internal val Res.string.action_request: StringResource by lazy {
      StringResource("string:action_request", "action_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 46),
      ))
    }

@delegate:ResourceContentHash(867_353_065)
internal val Res.string.action_sign_in: StringResource by lazy {
      StringResource("string:action_sign_in", "action_sign_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86, 38),
      ))
    }

@delegate:ResourceContentHash(173_028_883)
internal val Res.string.admin_accounts: StringResource by lazy {
      StringResource("string:admin_accounts", "admin_accounts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 125, 42),
      ))
    }

@delegate:ResourceContentHash(56_697_664)
internal val Res.string.admin_approve: StringResource by lazy {
      StringResource("string:admin_approve", "admin_approve", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 168, 33),
      ))
    }

@delegate:ResourceContentHash(-501_135_751)
internal val Res.string.admin_confirm_reset: StringResource by lazy {
      StringResource("string:admin_confirm_reset", "admin_confirm_reset", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 202, 119),
      ))
    }

@delegate:ResourceContentHash(-1_174_036_413)
internal val Res.string.admin_confirm_revoke: StringResource by lazy {
      StringResource("string:admin_confirm_revoke", "admin_confirm_revoke", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 322, 116),
      ))
    }

@delegate:ResourceContentHash(-84_223_399)
internal val Res.string.admin_inactive: StringResource by lazy {
      StringResource("string:admin_inactive", "admin_inactive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 439, 54),
      ))
    }

@delegate:ResourceContentHash(-843_890_757)
internal val Res.string.admin_make_admin: StringResource by lazy {
      StringResource("string:admin_make_admin", "admin_make_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 494, 52),
      ))
    }

@delegate:ResourceContentHash(-547_722_828)
internal val Res.string.admin_make_user: StringResource by lazy {
      StringResource("string:admin_make_user", "admin_make_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 547, 55),
      ))
    }

@delegate:ResourceContentHash(1_910_187_655)
internal val Res.string.admin_no_pending: StringResource by lazy {
      StringResource("string:admin_no_pending", "admin_no_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 603, 60),
      ))
    }

@delegate:ResourceContentHash(-1_492_576_357)
internal val Res.string.admin_pending: StringResource by lazy {
      StringResource("string:admin_pending", "admin_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 664, 49),
      ))
    }

@delegate:ResourceContentHash(-56_690_644)
internal val Res.string.admin_reactivate: StringResource by lazy {
      StringResource("string:admin_reactivate", "admin_reactivate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 714, 40),
      ))
    }

@delegate:ResourceContentHash(1_937_744_869)
internal val Res.string.admin_reject: StringResource by lazy {
      StringResource("string:admin_reject", "admin_reject", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 755, 32),
      ))
    }

@delegate:ResourceContentHash(-1_721_806_036)
internal val Res.string.admin_reset_password: StringResource by lazy {
      StringResource("string:admin_reset_password", "admin_reset_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 788, 68),
      ))
    }

@delegate:ResourceContentHash(1_311_051_485)
internal val Res.string.admin_revoke: StringResource by lazy {
      StringResource("string:admin_revoke", "admin_revoke", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 857, 44),
      ))
    }

@delegate:ResourceContentHash(-1_442_567_393)
internal val Res.string.admin_role_admin: StringResource by lazy {
      StringResource("string:admin_role_admin", "admin_role_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 32),
      ))
    }

@delegate:ResourceContentHash(-1_168_932_637)
internal val Res.string.admin_temporary_password: StringResource by lazy {
      StringResource("string:admin_temporary_password", "admin_temporary_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1006, 112),
      ))
    }

@delegate:ResourceContentHash(-793_191_986)
internal val Res.string.admin_temporary_password_title: StringResource by lazy {
      StringResource("string:admin_temporary_password_title", "admin_temporary_password_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 935, 70),
      ))
    }

@delegate:ResourceContentHash(-1_498_018_714)
internal val Res.string.admin_title: StringResource by lazy {
      StringResource("string:admin_title", "admin_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1119, 39),
      ))
    }

@delegate:ResourceContentHash(-1_865_816_066)
internal val Res.string.admin_user_actions: StringResource by lazy {
      StringResource("string:admin_user_actions", "admin_user_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1159, 50),
      ))
    }

@delegate:ResourceContentHash(3_049_210)
internal val Res.string.admin_you: StringResource by lazy {
      StringResource("string:admin_you", "admin_you", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1210, 21),
      ))
    }

@delegate:ResourceContentHash(-1_860_369_025)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1232, 28),
      ))
    }

@delegate:ResourceContentHash(-692_171_734)
internal val Res.string.auth_subtitle: StringResource by lazy {
      StringResource("string:auth_subtitle", "auth_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1261, 101),
      ))
    }

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1363, 20),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1384, 26),
      ))
    }

@delegate:ResourceContentHash(1_925_029_969)
internal val Res.string.change_password_done: StringResource by lazy {
      StringResource("string:change_password_done", "change_password_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1411, 112),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1524, 21),
      ))
    }

@delegate:ResourceContentHash(1_976_862_229)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1546, 27),
      ))
    }

@delegate:ResourceContentHash(2_121_146_648)
internal val Res.string.error_email_invalid: StringResource by lazy {
      StringResource("string:error_email_invalid", "error_email_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1574, 59),
      ))
    }

@delegate:ResourceContentHash(841_725_367)
internal val Res.string.error_email_taken: StringResource by lazy {
      StringResource("string:error_email_taken", "error_email_taken", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1634, 85),
      ))
    }

@delegate:ResourceContentHash(78_985_312)
internal val Res.string.error_fields_required: StringResource by lazy {
      StringResource("string:error_fields_required", "error_fields_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1720, 61),
      ))
    }

@delegate:ResourceContentHash(-1_301_400_051)
internal val Res.string.error_forbidden: StringResource by lazy {
      StringResource("string:error_forbidden", "error_forbidden", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1782, 47),
      ))
    }

@delegate:ResourceContentHash(-378_762_924)
internal val Res.string.error_invalid: StringResource by lazy {
      StringResource("string:error_invalid", "error_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1916, 65),
      ))
    }

@delegate:ResourceContentHash(-1_992_795_527)
internal val Res.string.error_invalid_credentials: StringResource by lazy {
      StringResource("string:error_invalid_credentials", "error_invalid_credentials", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1830, 85),
      ))
    }

@delegate:ResourceContentHash(498_196_805)
internal val Res.string.error_message_long: StringResource by lazy {
      StringResource("string:error_message_long", "error_message_long", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1982, 74),
      ))
    }

@delegate:ResourceContentHash(-1_443_659_129)
internal val Res.string.error_password_short: StringResource by lazy {
      StringResource("string:error_password_short", "error_password_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2057, 80),
      ))
    }

@delegate:ResourceContentHash(-1_241_174_784)
internal val Res.string.error_pending: StringResource by lazy {
      StringResource("string:error_pending", "error_pending", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2138, 77),
      ))
    }

@delegate:ResourceContentHash(952_247_461)
internal val Res.string.error_refused: StringResource by lazy {
      StringResource("string:error_refused", "error_refused", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2216, 77),
      ))
    }

@delegate:ResourceContentHash(-713_794_619)
internal val Res.string.error_too_many_attempts: StringResource by lazy {
      StringResource("string:error_too_many_attempts", "error_too_many_attempts", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2294, 87),
      ))
    }

@delegate:ResourceContentHash(123_821_476)
internal val Res.string.error_unreachable: StringResource by lazy {
      StringResource("string:error_unreachable", "error_unreachable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2382, 85),
      ))
    }

@delegate:ResourceContentHash(-124_548_343)
internal val Res.string.error_username_rules: StringResource by lazy {
      StringResource("string:error_username_rules", "error_username_rules", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2468, 104),
      ))
    }

@delegate:ResourceContentHash(-40_438_422)
internal val Res.string.error_username_taken: StringResource by lazy {
      StringResource("string:error_username_taken", "error_username_taken", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2573, 64),
      ))
    }

@delegate:ResourceContentHash(-209_873_554)
internal val Res.string.error_wrong_current_password: StringResource by lazy {
      StringResource("string:error_wrong_current_password", "error_wrong_current_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2638, 76),
      ))
    }

@delegate:ResourceContentHash(786_821_472)
internal val Res.string.field_current_password: StringResource by lazy {
      StringResource("string:field_current_password", "field_current_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2715, 58),
      ))
    }

@delegate:ResourceContentHash(-957_383_799)
internal val Res.string.field_email: StringResource by lazy {
      StringResource("string:field_email", "field_email", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2774, 27),
      ))
    }

@delegate:ResourceContentHash(-1_853_651_783)
internal val Res.string.field_login: StringResource by lazy {
      StringResource("string:field_login", "field_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2802, 43),
      ))
    }

@delegate:ResourceContentHash(-455_765_341)
internal val Res.string.field_message: StringResource by lazy {
      StringResource("string:field_message", "field_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2846, 77),
      ))
    }

@delegate:ResourceContentHash(-1_051_559_245)
internal val Res.string.field_new_password: StringResource by lazy {
      StringResource("string:field_new_password", "field_new_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2924, 74),
      ))
    }

@delegate:ResourceContentHash(-799_443_163)
internal val Res.string.field_password: StringResource by lazy {
      StringResource("string:field_password", "field_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2999, 38),
      ))
    }

@delegate:ResourceContentHash(746_765_076)
internal val Res.string.field_replacement_password: StringResource by lazy {
      StringResource("string:field_replacement_password", "field_replacement_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3038, 90),
      ))
    }

@delegate:ResourceContentHash(-373_341_880)
internal val Res.string.field_username: StringResource by lazy {
      StringResource("string:field_username", "field_username", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3221, 30),
      ))
    }

@delegate:ResourceContentHash(-711_404_620)
internal val Res.string.field_username_hint: StringResource by lazy {
      StringResource("string:field_username_hint", "field_username_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3129, 91),
      ))
    }

@delegate:ResourceContentHash(-1_999_713_498)
internal val Res.string.hide_password: StringResource by lazy {
      StringResource("string:hide_password", "hide_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3252, 33),
      ))
    }

@delegate:ResourceContentHash(-1_498_018_714)
internal val Res.string.menu_admin: StringResource by lazy {
      StringResource("string:menu_admin", "menu_admin", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3286, 38),
      ))
    }

@delegate:ResourceContentHash(-1_434_210_325)
internal val Res.string.menu_change_password: StringResource by lazy {
      StringResource("string:menu_change_password", "menu_change_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3325, 60),
      ))
    }

@delegate:ResourceContentHash(-102_467_363)
internal val Res.string.menu_sign_out: StringResource by lazy {
      StringResource("string:menu_sign_out", "menu_sign_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3386, 41),
      ))
    }

@delegate:ResourceContentHash(-1_954_680_927)
internal val Res.string.refresh: StringResource by lazy {
      StringResource("string:refresh", "refresh", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3428, 31),
      ))
    }

@delegate:ResourceContentHash(1_136_063_644)
internal val Res.string.request_sent: StringResource by lazy {
      StringResource("string:request_sent", "request_sent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3460, 136),
      ))
    }

@delegate:ResourceContentHash(1_420_507_852)
internal val Res.string.retry: StringResource by lazy {
      StringResource("string:retry", "retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3597, 29),
      ))
    }

@delegate:ResourceContentHash(-304_894_782)
internal val Res.string.show_password: StringResource by lazy {
      StringResource("string:show_password", "show_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3627, 33),
      ))
    }

@delegate:ResourceContentHash(222_657_137)
internal val Res.string.startup_unreachable: StringResource by lazy {
      StringResource("string:startup_unreachable", "startup_unreachable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3661, 87),
      ))
    }

@delegate:ResourceContentHash(-529_350_967)
internal val Res.string.status_rejected: StringResource by lazy {
      StringResource("string:status_rejected", "status_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3749, 35),
      ))
    }

@delegate:ResourceContentHash(-1_626_034_727)
internal val Res.string.status_revoked: StringResource by lazy {
      StringResource("string:status_revoked", "status_revoked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3785, 34),
      ))
    }

@delegate:ResourceContentHash(465_868_436)
internal val Res.string.tab_request: StringResource by lazy {
      StringResource("string:tab_request", "tab_request", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3820, 43),
      ))
    }

@delegate:ResourceContentHash(-1_954_119_240)
internal val Res.string.tab_sign_in: StringResource by lazy {
      StringResource("string:tab_sign_in", "tab_sign_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3864, 31),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("account_menu", Res.string.account_menu)
  map.put("action_request", Res.string.action_request)
  map.put("action_sign_in", Res.string.action_sign_in)
  map.put("admin_accounts", Res.string.admin_accounts)
  map.put("admin_approve", Res.string.admin_approve)
  map.put("admin_confirm_reset", Res.string.admin_confirm_reset)
  map.put("admin_confirm_revoke", Res.string.admin_confirm_revoke)
  map.put("admin_inactive", Res.string.admin_inactive)
  map.put("admin_make_admin", Res.string.admin_make_admin)
  map.put("admin_make_user", Res.string.admin_make_user)
  map.put("admin_no_pending", Res.string.admin_no_pending)
  map.put("admin_pending", Res.string.admin_pending)
  map.put("admin_reactivate", Res.string.admin_reactivate)
  map.put("admin_reject", Res.string.admin_reject)
  map.put("admin_reset_password", Res.string.admin_reset_password)
  map.put("admin_revoke", Res.string.admin_revoke)
  map.put("admin_role_admin", Res.string.admin_role_admin)
  map.put("admin_temporary_password", Res.string.admin_temporary_password)
  map.put("admin_temporary_password_title", Res.string.admin_temporary_password_title)
  map.put("admin_title", Res.string.admin_title)
  map.put("admin_user_actions", Res.string.admin_user_actions)
  map.put("admin_you", Res.string.admin_you)
  map.put("app_name", Res.string.app_name)
  map.put("auth_subtitle", Res.string.auth_subtitle)
  map.put("back", Res.string.back)
  map.put("cancel", Res.string.cancel)
  map.put("change_password_done", Res.string.change_password_done)
  map.put("close", Res.string.close)
  map.put("confirm", Res.string.confirm)
  map.put("error_email_invalid", Res.string.error_email_invalid)
  map.put("error_email_taken", Res.string.error_email_taken)
  map.put("error_fields_required", Res.string.error_fields_required)
  map.put("error_forbidden", Res.string.error_forbidden)
  map.put("error_invalid", Res.string.error_invalid)
  map.put("error_invalid_credentials", Res.string.error_invalid_credentials)
  map.put("error_message_long", Res.string.error_message_long)
  map.put("error_password_short", Res.string.error_password_short)
  map.put("error_pending", Res.string.error_pending)
  map.put("error_refused", Res.string.error_refused)
  map.put("error_too_many_attempts", Res.string.error_too_many_attempts)
  map.put("error_unreachable", Res.string.error_unreachable)
  map.put("error_username_rules", Res.string.error_username_rules)
  map.put("error_username_taken", Res.string.error_username_taken)
  map.put("error_wrong_current_password", Res.string.error_wrong_current_password)
  map.put("field_current_password", Res.string.field_current_password)
  map.put("field_email", Res.string.field_email)
  map.put("field_login", Res.string.field_login)
  map.put("field_message", Res.string.field_message)
  map.put("field_new_password", Res.string.field_new_password)
  map.put("field_password", Res.string.field_password)
  map.put("field_replacement_password", Res.string.field_replacement_password)
  map.put("field_username", Res.string.field_username)
  map.put("field_username_hint", Res.string.field_username_hint)
  map.put("hide_password", Res.string.hide_password)
  map.put("menu_admin", Res.string.menu_admin)
  map.put("menu_change_password", Res.string.menu_change_password)
  map.put("menu_sign_out", Res.string.menu_sign_out)
  map.put("refresh", Res.string.refresh)
  map.put("request_sent", Res.string.request_sent)
  map.put("retry", Res.string.retry)
  map.put("show_password", Res.string.show_password)
  map.put("startup_unreachable", Res.string.startup_unreachable)
  map.put("status_rejected", Res.string.status_rejected)
  map.put("status_revoked", Res.string.status_revoked)
  map.put("tab_request", Res.string.tab_request)
  map.put("tab_sign_in", Res.string.tab_sign_in)
}
